import notEnabledImage from 'assets/images/cms/ordering-not-enabled.png'
import { buildTranslate } from 'locales'
import React from 'react'
import CmsPage from 'scenes/Cms/components/CmsPage'

const t = buildTranslate('cms.settings.ordering_not_enabled_page')

const OrderingNotEnabledPage: React.FC<{ showTitle?: boolean }> = ({
  showTitle = true,
}) => {
  return (
    <CmsPage
      showTitle={showTitle}
      title={t('title')}
      description={t('description')}
      contactButtonTitle={t('contact_our_team')}
    >
      <img
        className="max-width-100"
        src={notEnabledImage}
        alt={t('image_alt')}
      />
      <p className="mt-xs mb-l text-right font-size-12 grey-70">
        {t('image_alt')}
      </p>
    </CmsPage>
  )
}

export default OrderingNotEnabledPage
